import React from 'react';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const PREFIX = 'DRO';

const classes = {
  dro: `${PREFIX}-dro`,
  pre: `${PREFIX}-pre`,
  table: `${PREFIX}-table`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.dro}`]: {
    borderRadius: 10,
    padding: "10px",
    backgroundColor: "rgba(100,100,100,.75)",
    color: "white",
    marginTop: 10,
    textAlign: "right",
    minWidth: "90px"
  },

  [`& table.${classes.table} td`]: {
    border: 0,
    padding: 0,
    fontFamily: "monospace",
    color: "white",
    fontSize: "small"
  }

}));
const DRO = ((props) => {
  const {
    X,Y,Z,A,B,C,T
  } = props;

  return (
    <Root>
      <div className={classes.dro }>
      <TableContainer>
        <Table size="small" classes={{ root: classes.table }}>
          <TableBody>
            <TableRow><TableCell align="left">X:</TableCell><TableCell align="right">{X}</TableCell></TableRow>
            <TableRow><TableCell align="left">Y:</TableCell><TableCell align="right">{Y}</TableCell></TableRow>
            <TableRow><TableCell align="left">Z:</TableCell><TableCell align="right">{Z}</TableCell></TableRow>
            { typeof(A) !== "undefined" ? <TableRow><TableCell align="left">A:</TableCell><TableCell align="right">{A}</TableCell></TableRow> : null }
            { typeof(B) !== "undefined" ? <TableRow><TableCell align="left">B:</TableCell><TableCell align="right">{B}</TableCell></TableRow> : null }
            { typeof(C) !== "undefined" ? <TableRow><TableCell align="left">C:</TableCell><TableCell align="right">{C}</TableCell></TableRow> : null }
            <TableRow><TableCell align="left">T:</TableCell><TableCell align="right">{T}</TableCell></TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      </div>
    </Root>
  );
});

export default DRO;
